import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useSelector, useDispatch } from 'react-redux';

import { setShowProfileMgmtModal } from 'store/slice/HeaderSlice'
import ProfileMgmtModalContainer from './ProfileMgmtModalContainer';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  width: { lg: '560px', md: '560px', sm: '88%', xs: '92%' },
  maxWidth: '92vw',
  height: 'auto',
  maxHeight: '85vh',
  borderRadius: 3,
  overflowY: 'auto',
  p: 1,
  backgroundColor:'secondary.lighter',
};

export default function ProfileMgmtModal() {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);;
  const {showProfileMgmtModal} = useSelector((state)=>state.headerslice);
  const {isLoggedIn} = useSelector((state)=>state.headerslice);

  useEffect(()=>{
  },[showProfileMgmtModal])

  useEffect(()=>{
    handleModalClose();
  },[])

  const handleModalClose=()=>{
    handleClose();
    dispatch(setShowProfileMgmtModal(false));
  }
  return (
    <Modal
       open={showProfileMgmtModal===undefined?false:showProfileMgmtModal}
      onClose={handleModalClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style} >

        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Grid item>
            <Typography variant="h5"  >
              Profile Management
            </Typography>
          </Grid>
          <Grid item>
            <CloseIcon sx={{ cursor: "pointer" }} onClick={() => handleModalClose()} />
          </Grid>
        </Grid>
        <Grid item>
          <Divider />
          <Box height="20px"></Box>
        </Grid>
        <Grid item>
            < ProfileMgmtModalContainer/>
        </Grid>

      </Box>
    </Modal>
  );
}
